export default __webpack_public_path__ + "img/angular.b5045666.jpg";